export const SCHEDULE_DROPPABLE_ID = "game-schedule";
export const UNSCHEDULED_LIST_DROPPABLE_ID = "unscheduled-games";
export const GAME_BOX_DRAGGABLE_PREFIX = "game-";